export const VIEW_PATHS = {
  overview: "/",
  chart: "/chart",
  positions: "/positions",
  daily_pnl: "/daily-pnl",
  signals: "/signals",
  news: "/news",
  agents: "/agents",
  backtest: "/backtest",
  research: "/research",
  ai: "/ai",
  activity: "/activity",
  all_logs: "/all-logs",
  blockchain: "/blockchain",
  market_universe: "/market-universe",
  settings: "/settings",
};

const PATH_TO_VIEW = new Map(Object.entries(VIEW_PATHS).map(([view, path]) => [path, view]));

function normalizePathname(pathname) {
  const trimmed = String(pathname || "/").replace(/\/+$/, "");
  return trimmed || "/";
}

export function isKnownView(view) {
  return Object.prototype.hasOwnProperty.call(VIEW_PATHS, view);
}

export function pathForView(view) {
  return VIEW_PATHS[view] || VIEW_PATHS.overview;
}

export function routeFromLocation(location) {
  const pathname = normalizePathname(location?.pathname);
  const legacyPath = normalizePathname(String(location?.hash || "").replace(/^#/, ""));
  const legacyView = PATH_TO_VIEW.get(legacyPath);
  if (pathname === "/" && legacyView) {
    return { view: legacyView, unknown: false, pathname: legacyPath };
  }
  const view = PATH_TO_VIEW.get(pathname);
  if (view) return { view, unknown: false, pathname };
  return { view: "not_found", unknown: true, pathname };
}
